import CompanyDetailsEditCard from './CompanyDetailsEditCard';

export default CompanyDetailsEditCard;
